<template>
  <div class="voz-guideline-adaptable-content" id="identidade-verbal-voz-adaptavel-e-detalhista" data-search-anchor>
    <h1 class="voz-guideline-adaptable-title">{{ vozGuidelineAdaptableTitle }}</h1>
    <p class="voz-guideline-adaptable-paragraph">{{ vozGuidelineAdaptableParagraph }}</p>

    <div class="voz-guideline-adaptable-wrapper">
      <div
        class="voz-guideline-adaptable-container-img"
        :style="{ backgroundImage: `url(${vozGuidelineAdaptableImageSrc})` }"
      >
        <div class="voz-guideline-adaptable-overlay">
          <h1 class="voz-guideline-adaptable-number">3</h1>

          <div class="voz-guideline-adaptable-content-text">
            <h3 class="voz-guideline-adaptable-card-title">
              {{ vozGuidelineAdaptableCardTitle }}
            </h3>

            <p class="voz-guideline-adaptable-text">
              {{ vozGuidelineAdaptableText }}
            </p>
          </div>
        </div>
      </div>

      <div class="voz-guideline-adaptable-column">
        <div class="voz-adaptable-icon-paragraph-title">
          <IconCheck />
          <h1 class="voz-guideline-adaptable-prefer-paragraph-title">
            {{ vozGuidelineAdaptableParagraphPref }}
          </h1>
        </div>
        <p class="voz-guideline-adaptable-prefer-paragraph">{{ vozGuidelinePreferParagraph1 }}</p>
        <p class="voz-guideline-adaptable-prefer-paragraph">{{ vozGuidelinePreferParagraph2 }}</p>
        <p class="voz-guideline-adaptable-prefer-paragraph">{{ vozGuidelinePreferParagraph3 }}</p>
        <p class="voz-guideline-adaptable-prefer-paragraph">{{ vozGuidelinePreferParagraph4 }}</p>

        <div class="voz-adaptable-icon-paragraph-title" style="margin-top: 104px">
          <IconCancel />
          <h1 class="voz-guideline-adaptable-prefer-paragraph-title">
            {{ vozGuidelineAdaptableParagraphEvit }}
          </h1>
        </div>
        <p class="voz-guideline-adaptable-prefer-paragraph">{{ vozGuidelineEvitParagraph5 }}</p>
        <p class="voz-guideline-adaptable-prefer-paragraph">{{ vozGuidelineEvitParagraph6 }}</p>
        <p class="voz-guideline-adaptable-prefer-paragraph">{{ vozGuidelineEvitParagraph7 }}</p>
      </div>

      <div class="gap-col"></div>

      <div class="voz-guideline-adaptable-column">
        <div class="voz-adaptable-icon-paragraph-title">
          <IconCheck />
          <h1 class="voz-guideline-adaptable-prefer-paragraph-title">
            {{ vozGuidelineAdaptableParagraphExempl }}
          </h1>
        </div>
        <p class="voz-guideline-adaptable-exempl-paragraph">
          {{ vozGuidelineExemplParagraphEvit1 }}
        </p>
        <p class="voz-guideline-adaptable-exempl-paragraph">
          {{ vozGuidelineExemplParagraphEvit2 }}
        </p>
        <p class="voz-guideline-adaptable-exempl-paragraph">
          {{ vozGuidelineExemplParagraphEvit3 }}
        </p>

        <div class="voz-adaptable-icon-paragraph-title" style="margin-top: 94px">
          <IconCancel />
          <h1 class="voz-guideline-adaptable-prefer-paragraph-title">
            {{ vozGuidelineAdaptableParagraphExempl2 }}
          </h1>
        </div>
        <p class="voz-guideline-adaptable-exempl-paragraph">
          {{ vozGuidelineExemplParagraphEvit4 }}
        </p>
        <p class="voz-guideline-adaptable-exempl-paragraph">
          {{ vozGuidelineExemplParagraphEvit5 }}
        </p>
        <p class="voz-guideline-adaptable-exempl-paragraph">
          {{ vozGuidelineExemplParagraphEvit6 }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import IconCancel from '@/assets/icons/IconCancel.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import VozPageMixin from '@/mixins/voz-page-mixin'
import { VozPageStore } from '@/store/verbal-identity-page/voz-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck, IconCancel } })
export default class VozGuidelineAdaptableSection extends Mixins(VozPageMixin) {
  vozPageStore: PageStoreContract = getModule(VozPageStore, this.$store)

  get vozGuidelineAdaptableTitle(): string {
    return this.getElementTitle(6, 0)
  }

  get vozGuidelineAdaptableParagraph(): string {
    return this.getElementText(6, 1)
  }

  get vozGuidelineAdaptableImageSrc(): string {
    return this.getElementMedia(6, 2)
  }

  get vozGuidelineAdaptableCardTitle(): string {
    return this.getElementTitle(3, 8)
  }

  get vozGuidelineAdaptableText(): string {
    return this.getElementText(3, 8)
  }

  //colum pref
  get vozGuidelineAdaptableParagraphPref(): string {
    return this.getElementTitle(6, 3)
  }

  get vozGuidelinePreferParagraph1(): string {
    return this.getElementText(6, 3)
  }

  get vozGuidelinePreferParagraph2(): string {
    return this.getElementText(6, 4)
  }

  get vozGuidelinePreferParagraph3(): string {
    return this.getElementText(6, 5)
  }

  get vozGuidelinePreferParagraph4(): string {
    return this.getElementText(6, 6)
  }

  //colum evit
  get vozGuidelineAdaptableParagraphEvit(): string {
    return this.getElementTitle(6, 7)
  }

  get vozGuidelineEvitParagraph5(): string {
    return this.getElementText(6, 7)
  }

  get vozGuidelineEvitParagraph6(): string {
    return this.getElementText(6, 8)
  }

  get vozGuidelineEvitParagraph7(): string {
    return this.getElementText(6, 9)
  }

  //colum exempl
  get vozGuidelineAdaptableParagraphExempl(): string {
    return this.getElementTitle(6, 10)
  }

  get vozGuidelineExemplParagraphEvit1(): string {
    return this.getElementText(6, 10)
  }

  get vozGuidelineExemplParagraphEvit2(): string {
    return this.getElementText(6, 11)
  }

  get vozGuidelineExemplParagraphEvit3(): string {
    return this.getElementText(6, 12)
  }

  //colum exempl2
  get vozGuidelineAdaptableParagraphExempl2(): string {
    return this.getElementTitle(6, 13)
  }

  get vozGuidelineExemplParagraphEvit4(): string {
    return this.getElementText(6, 13)
  }

  get vozGuidelineExemplParagraphEvit5(): string {
    return this.getElementText(6, 14)
  }

  get vozGuidelineExemplParagraphEvit6(): string {
    return this.getElementText(6, 15)
  }

  get vozGuidelineExemplParagraphEvit7(): string {
    return this.getElementText(6, 16)
  }

  async getVozPage(): Promise<void> {
    await this.vozPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.vozPageStore.isLoading) {
      await this.getVozPage()
    }
  }
}
</script>

<style lang="scss">
.voz-guideline-adaptable-content {
  display: grid;
  justify-content: center;
  margin-top: 150px;
  max-width: 1032px;
}

.voz-guideline-adaptable-title {
  font-size: 48px;
  font-weight: 400;
  line-height: 52px;
  letter-spacing: -0.01em;
  text-align: center;
  width: 976px;
  margin: 0 auto;
}

.voz-guideline-adaptable-paragraph {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  width: 503px;
  margin: 0 auto;
  margin-top: 49px;
}

.voz-guideline-adaptable-wrapper {
  display: grid;
  grid-template-columns: 369px 307px 50px 307px;
  width: 1032px;
  margin: 0 auto;
  margin-top: 148px;
}

.voz-guideline-adaptable-container-img {
  width: 341px;
  height: 681px;
  border-radius: 16px;
  overflow: hidden;

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  position: relative;
}

.voz-guideline-adaptable-overlay {
  position: absolute;
  inset: 0;

  padding: 24px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  color: #fff;
}

.voz-guideline-adaptable-number {
  font-size: 267px;
  font-weight: 600;
  margin: 0;
}

.voz-guideline-adaptable-content-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.voz-guideline-adaptable-card-title {
  font-family: GlobotipoCorporativaRegular;
  font-size: 28px;
  font-weight: 400;
  width: 140px;
  margin: 0;
}

.voz-guideline-adaptable-text {
  font-family: GlobotipoCorporativaTextosRegular;
  font-size: 18px;
  width: 200px;
  margin: 0;
}

.voz-guideline-adaptable-column {
  display: flex;
  flex-direction: column;
}

.voz-adaptable-icon-paragraph-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.voz-guideline-adaptable-prefer-paragraph-title {
  font-weight: 400;
  font-size: 32px;
  line-height: 36px;
}

.voz-guideline-adaptable-prefer-paragraph,
.voz-guideline-adaptable-exempl-paragraph {
  margin-top: 0;
}

.voz-guideline-adaptable-prefer-paragraph,
.voz-guideline-adaptable-exempl-paragraph {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.voz-guideline-adaptable-exempl-paragraph:last-of-type {
  white-space: pre-wrap;
}
</style>
